export const BillingEnum = Object.freeze({
  DRAFT: "draft",
  PENDING: "pending",
  APPROVED: "approved",
  CANCELLED: "cancelled",
});

export const getBillingKey = (value) =>
  Object.entries(BillingEnum).find(([, v]) => v === value)?.[0] ?? value;

export const getBillingLabel = (value) => {
  const labels = {
    [BillingEnum.DRAFT]: "Rascunho",
    [BillingEnum.PENDING]: "Pendente",
    [BillingEnum.APPROVED]: "Aprovado",
    [BillingEnum.CANCELLED]: "Cancelado",
  };

  return labels[value] ?? value;
};
